(function() {
    'use strict';

    angular
        .module('app')
        .directive('controlPosition', controlPosition);

    controlPosition.$inject = ['$window'];
    
    function controlPosition ($window) {
        // Usage:
        //     <controlPosition></controlPosition>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                left: '=',
                top: '=',
                width: '=',
                height: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$evalAsync(function () {
                element.css('position', 'absolute');
                element.css('top', scope.top + 'px');
                element.css('left', scope.left + 'px');
                element.css('width', scope.width + 'px');
                element.css('height', scope.height + 'px');
            });
        }
    }

})();